export const ReqCount = 10;

export const aggregators = [
  {
    type: 'longSum',
    name: 'ticket',
    fieldName: 'ticket',
  },
  {
    type: 'longSum',
    name: 'piece',
    fieldName: 'piece',
  },
  {
    type: 'doubleSum',
    name: 'goodsWeight',
    fieldName: 'goodsWeight',
  },
  {
    type: 'doubleSum',
    name: 'goodsVolume',
    fieldName: 'goodsVolume',
  },
  // {
  //   type: 'longSum',
  //   name: 'ticket',
  //   fieldName: 'ticket',
  // }
];

export const aggCalcWeight = [
  {
    type: 'doubleSum',
    name: 'calcWeight',
    fieldName: 'calcWeight',
  },
];

export const convFilters = (filter, p1, p2, p3) =>
  filter
    ? Object.entries(filter).map(([key, value]) => {
        if (value === '$p1') return { key, value: p1 };
        if (value === '$p2') return { key, value: p2 };
        if (value === '$p3') return { key, value: p3 };
        return { key, value };
      })
    : [];

export const convBoundFilter = (filter, p1, p2, p3) => {
  let result = [];
  if (filter) {
    result = filter.map(filteItem => {
      const temp = {};
      Object.entries(filteItem).map(([key, value]) => {
        if (value === '$p1') return (temp[key] = p1);
        if (value === '$p2') return (temp[key] = p2);
        if (value === '$p3') return (temp[key] = p3);
        temp[key] = value;
      });
      return temp;
    });
  }
  return result;
};

//保留2位小数，不足补0
export const computeWeightAddZero = value => {
  var value = Math.round(parseFloat(Math.abs(value) / 1000) * 100) / 100;
  var s = value.toString().split('.');
  if (s.length == 1) {
    value = value.toString() + '.00';
    return value;
  }
  if (s.length > 1) {
    if (s[1].length < 2) {
      value = value.toString() + '0';
    }
    return value;
  }
};

export const computeWeight = (weight, demLen = 2) =>
  weight ? Number.parseFloat((Math.abs(weight) / 1000).toFixed(demLen)) : 0;

export const computeWeights = (weight, demLen = 1) => {
  let weights = weight || 0;
  if (weights) {
    const div = Math.abs(weights) / 1000;
    weights = Number.parseFloat(div.toFixed(div > 0.1 ? demLen : div > 0.01 ? 2 : 3));
  }
  return weights;
};

export const computeWeightNotAbs = weight => {
  let weights = weight || 0;
  if (weights) {
    const div = weight / 1000;
    weights = div.toFixed(div > 0.1 ? 1 : 2);
    return Number.parseFloat(weights);
  }
  return weights;
};

export const computeWeightNotAbsTwo = weight => {
  let weights = weight || 0;
  if (weights) {
    const div = weight / 1000;
    weights = div.toFixed(2);
    return Number.parseFloat(weights);
  }
  return weights;
};

export const getProductType = () => [
  '定时达',
  'MINI电商大件',
  'MINI电商小件',
  '安心达',
  '普惠达',
  '精准零担',
];

//根据日期获取是周几
export const getDayOfWeek = date => {
  var arr = new Array('日', '一', '二', '三', '四', '五', '六');
  var week = new Date(date).getDay();
  var str = '星期' + arr[week];
  return str;
};

export const getWeekIdx = week => {
  var arr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
  return arr.indexOf(week);
};
